<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<div class="figure" style="text-align: center;">
<img alt="" src="media/file0.jpg" style="width:1.41116in;height:2.54in"/>
<p class="caption">C:\Users\ViralWebbs\Pictures\2.jpg</p>
</div>
<p>Michael Eicherly was born in Garden Grove California, on January 10<sup>th</sup>, 1969. He currently lives in the Mission District of San Gabriel, California. Together, he and his wife have three children. His passions are horror films, music, books, family and Lucky Baldwin pubs.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?68dba8e4